import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1a5f1507"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "page-container"
};
var _hoisted_2 = {
  class: "nav-header-box"
};
var _hoisted_3 = {
  class: "page-inner-container"
};
var _hoisted_4 = {
  class: "faq-list-box"
};
var _hoisted_5 = {
  class: "page-inner-container"
};
var _hoisted_6 = {
  key: "noc"
};
var _hoisted_7 = {
  key: "qecit"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Banner = _resolveComponent("Banner");

  var _component_NavHeader = _resolveComponent("NavHeader");

  var _component_FaqNOC = _resolveComponent("FaqNOC");

  var _component_FaqQECIT = _resolveComponent("FaqQECIT");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Banner, {
    image: _ctx.BannerImage
  }, null, 8, ["image"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_NavHeader, {
    list: _ctx.activityTypeList,
    onChange: _ctx.onActivityTypeChange
  }, null, 8, ["list", "onChange"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("div", _hoisted_6, [_createVNode(_component_FaqNOC)], 512), [[_vShow, _ctx.current === 1]]), _withDirectives(_createElementVNode("div", _hoisted_7, [_createVNode(_component_FaqQECIT)], 512), [[_vShow, _ctx.current === 2]])])])]);
}